import TagManager from 'react-gtm-module';

import {
  DeferredNavigationProps,
  deferredNavigationFields,
} from './clickTracking';

export interface TrackPlpCrossLinkingCardClickProps
  extends DeferredNavigationProps {
  data: {
    interactionLocation: string;
    linkUrl: string;
    linkText: string;
    coOpBrand: string | null;
    index: number;
  };
}

export const trackPlpCrossLinkingCardClick = ({
  data,
  ...deferral
}: TrackPlpCrossLinkingCardClickProps) => {
  const { interactionLocation, linkUrl, linkText, coOpBrand, index } = data;

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_name: 'click_crosslinking_card',
      interaction: {
        interaction_location: interactionLocation,
        link_url: linkUrl,
        link_text: linkText,
        coop_brand: coOpBrand,
        index,
      },
      ...deferredNavigationFields(deferral),
    },
  });
};

export interface TrackPlpCrossLinkingCtaClickProps
  extends DeferredNavigationProps {
  data: {
    /** Path the click happened on, e.g. `/en/products/camping-and-hiking` */
    interactionLocation: string;
    /** Resolved href of the band's CTA */
    linkUrl: string;
    linkText: string;
    coOpBrand: string | null;
  };
}

/**
 * The band's heading CTA ("Shop all …"). There is only one per band, so no
 * `index` is reported — unlike the cards, position carries no meaning here.
 */
export const trackPlpCrossLinkingCtaClick = ({
  data,
  ...deferral
}: TrackPlpCrossLinkingCtaClickProps) => {
  const { interactionLocation, linkUrl, linkText, coOpBrand } = data;

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_name: 'click_crosslinking_cta',
      interaction: {
        interaction_location: interactionLocation,
        link_url: linkUrl,
        link_text: linkText,
        coop_brand: coOpBrand,
      },
      ...deferredNavigationFields(deferral),
    },
  });
};
